/** Help-chat / handoff copy kept separate for LOC limits on locale files. */
export const helpChatExtraEn = {
  tickets: 'Tickets',
  ticketsKicker: 'Support',
  ticketsHint: 'Live chats and tickets for the selected house.',
  ticketsRoster: 'Ticket queue',
  ticketsEmptyHint: 'New tickets from help chat appear here.',
  knowledge: 'Knowledge',
  analytics: 'Analytics',
  supportOverview: 'Support hub',
  openTickets: 'Open tickets',
  auditEvents24h: 'Audit events',
  resolve: 'Resolve',
  noTickets: 'No tickets.',
  supportLiveQueued: 'Queued',
  supportLiveActive: 'Live',
  helpChatPlaceholder: 'Write your message…',
  knowledgeSearchPlaceholder: 'Ask about caps, cutoffs, plays…',
  helpChatSend: 'Send',
  search: 'Search',
  noResults: 'No matching guide yet.',
  sourcesCount: 'Published guides',
  docTitle: 'Guide title',
  docContent: 'Write the guide content…',
  indexDocument: 'Publish guide',
  noAudit: 'No events.',
  noAuditEvents: 'No events logged yet.',
  lastExportBatch: 'Last export batch',
  auditEventCount: 'Audit total',
  recentExports: 'Recent sample',
  analyticsHint: 'Aggregated BI data. Scheduled export every 15 min.',
  analyticsEmpty: 'No analytics yet. Data appears after support chats and scheduled exports.',
  helpChat: 'Help',
  knowledgeKicker: 'Guides',
  helpChatIntro: 'Caps, cutoffs, plays, results, and account.',
  helpChatGreeting: 'Hi! How can I help you today?',
  helpChatClose: 'Close chat',
  helpChatThinking: '…',
  helpChatTyping: 'Typing…',
  helpTicketCreated: 'I opened a support ticket with your message. Our team will follow up soon.',
  helpOpenTicket: 'Open support ticket',
  helpOpenTicketHint: 'Describe what happened and our team will follow up.',
  helpOpenTicketEmpty: 'Write a short description first, then open a ticket.',
  helpStaffNoTicket: 'Use the support workspace to manage tickets — this chat is for end users.',
  helpHandoffLive: 'Talk to an agent',
  helpHandoffTicket: 'Create a ticket',
  helpHandoffContinue: 'Keep chatting',
  helpHandoffTicketFailed: 'Could not create the ticket. You can try again or keep chatting.',
  helpLiveQueued: 'You are in the live support queue. An agent will join shortly.',
  helpLiveConnected: 'Connected to a live support agent.',
  helpLiveUnavailable: 'No agents are online right now. You can create a ticket instead.',
  helpLiveClosed: 'The live chat has ended.',
  helpLiveSendFailed: 'Could not send your message. Please try again.',
  supportLiveAgent: 'Agent',
  supportLiveQueue: 'Live chats',
  supportLiveEmpty: 'No live chats waiting.',
  supportLiveClaim: 'Accept',
  supportLiveClose: 'Close chat',
  helpReplySourceCloud: 'Cloud assistant',
  helpReplySourceLocal: 'Local assistant (offline)',
  helpReplySourceDegraded: 'Limited assistant — cloud unavailable',
  helpFeedbackThanks: 'Thanks for the feedback.',
  helpFeedbackPrompt: 'Was this helpful?',
  helpPromoteKnowledge: 'Promote to knowledge',
  helpPromotePending: 'Queued for knowledge approval',
  analyticsDeflection: 'AI deflection',
  analyticsHandoffRate: 'Handoff rate',
  analyticsGrounded: 'Grounded replies',
  analyticsRatings: 'Helpful ratings',
  myTickets: 'My tickets',
  myTicketsEmpty: 'You have not opened any tickets yet.',
  ticketNoMessages: 'No messages yet.',
  ticketThread: 'Ticket conversation',
  ticketReplyNotify: 'New reply on your ticket',
  viewTicketConversation: 'View conversation',
} as const;

export const helpChatExtraEs = {
  tickets: 'Tickets',
  ticketsKicker: 'Soporte',
  ticketsHint: 'Chats en vivo y tickets de la casa seleccionada.',
  ticketsRoster: 'Cola de tickets',
  ticketsEmptyHint: 'Los tickets nuevos del chat de ayuda aparecen aquí.',
  knowledge: 'Conocimiento',
  analytics: 'Analítica',
  supportOverview: 'Centro de soporte',
  openTickets: 'Tickets abiertos',
  auditEvents24h: 'Eventos audit',
  resolve: 'Resolver',
  noTickets: 'Sin tickets.',
  supportLiveQueued: 'En cola',
  supportLiveActive: 'En vivo',
  helpChatPlaceholder: 'Escribe tu mensaje…',
  knowledgeSearchPlaceholder: 'Pregunta por topes, cierres, jugadas…',
  helpChatSend: 'Enviar',
  search: 'Buscar',
  noResults: 'Aún no hay una guía que coincida.',
  sourcesCount: 'Guías publicadas',
  docTitle: 'Título de la guía',
  docContent: 'Escribe el contenido de la guía…',
  indexDocument: 'Publicar guía',
  noAudit: 'Sin eventos.',
  noAuditEvents: 'Aún no hay eventos registrados.',
  lastExportBatch: 'Último lote exportado',
  auditEventCount: 'Total audit',
  recentExports: 'Muestra reciente',
  analyticsHint: 'Datos agregados para BI. Export programado cada 15 min.',
  analyticsEmpty: 'Aún no hay analítica. Aparece tras chats de soporte y exportaciones programadas.',
  helpChat: 'Ayuda',
  knowledgeKicker: 'Guías',
  helpChatIntro: 'Topes, cierres, jugadas, resultados y cuenta.',
  helpChatGreeting: '¡Hola! ¿En qué te ayudo hoy?',
  helpChatClose: 'Cerrar chat',
  helpChatThinking: '…',
  helpChatTyping: 'Escribiendo…',
  helpTicketCreated: 'Abrí un ticket de soporte con tu mensaje. El equipo te responderá pronto.',
  helpOpenTicket: 'Abrir ticket de soporte',
  helpOpenTicketHint: 'Describe qué ocurrió y nuestro equipo te responderá.',
  helpOpenTicketEmpty: 'Escribe una breve descripción y luego abre el ticket.',
  helpStaffNoTicket: 'Usa el espacio de soporte para gestionar tickets — este chat es para usuarios finales.',
  helpHandoffLive: 'Hablar con un agente',
  helpHandoffTicket: 'Crear ticket',
  helpHandoffContinue: 'Seguir con el asistente',
  helpHandoffTicketFailed: 'No pude crear el ticket. Puedes reintentar o seguir en el chat.',
  helpLiveQueued: 'Estás en la cola de soporte en vivo. Un agente se unirá pronto.',
  helpLiveConnected: 'Conectado con un agente de soporte.',
  helpLiveUnavailable: 'No hay agentes en línea ahora. Puedes crear un ticket.',
  helpLiveClosed: 'El chat en vivo ha terminado.',
  helpLiveSendFailed: 'No se pudo enviar tu mensaje. Inténtalo de nuevo.',
  supportLiveAgent: 'Agente',
  supportLiveQueue: 'Chats en vivo',
  supportLiveEmpty: 'No hay chats en vivo en espera.',
  supportLiveClaim: 'Aceptar',
  supportLiveClose: 'Cerrar chat',
  helpReplySourceCloud: 'Asistente en la nube',
  helpReplySourceLocal: 'Asistente local (sin conexión)',
  helpReplySourceDegraded: 'Asistente limitado — nube no disponible',
  helpFeedbackThanks: 'Gracias por tu comentario.',
  helpFeedbackPrompt: '¿Te fue útil?',
  helpPromoteKnowledge: 'Promover a conocimiento',
  helpPromotePending: 'En cola para aprobación de conocimiento',
  analyticsDeflection: 'Desvío por IA',
  analyticsHandoffRate: 'Tasa de handoff',
  analyticsGrounded: 'Respuestas con evidencia',
  analyticsRatings: 'Valoraciones útiles',
  myTickets: 'Mis tickets',
  myTicketsEmpty: 'Aún no has abierto tickets.',
  ticketNoMessages: 'Aún no hay mensajes.',
  ticketThread: 'Conversación del ticket',
  ticketReplyNotify: 'Nueva respuesta en tu ticket',
  viewTicketConversation: 'Ver conversación',
} as const;
